<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .h-100.overflow-hidden(
      style="padding-top: 60px!important;"
    )
      .content.h-100.overflow-auto(
        style="padding-bottom: 70px;"
      )
        .mb-2.mx-3.p-3
          .mb-0.text-center(v-show="serials.length == 0") 無電子序號活動
          template(
            v-for="(activity, index) in serials"
          )
            .row.product.mb-3.px-3.py-2.outline-product.border-black.custom-shadow
              .content-product
                .input_wrap.d-flex
                  .product_info.row.w-100.h-100
                    .col
                      h6.mb-1 {{ activity.name }}
                    .col-auto.px-2.d-flex.align-itwems-center
                      button.btn.btn-block.btn-remind.font-weight-bold.btn-custom.px-3(
                        type="button",
                        @click="productsPush(activity.seq)",
                        style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
                        ) 發送

</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';
import tempTextModel from '@/components/customerModel/tempTextModel.vue';
import tempSendPreviewModel from '@/components/customerModel/tempSendPreviewModel.vue';
import UdRatio from '@/components/udon-ui/UdRatio.vue';

// 模板顯示部分
import textInput from '@/components/modalTemplate/messageText/textInput.vue';
import imageMapInput from '@/components/modalTemplate/messageImageMap/imageMapInput.vue';
import carouselInput from '@/components/modalTemplate/messageCarousel/carouselInput.vue';

const _ = require('lodash');

export default {
  name: 'LinePointModel',
  components: {
    InfiniteLoading,
    tempTextModel,
    tempSendPreviewModel,
    textInput,
    imageMapInput,
    carouselInput,
    UdRatio
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: null
    },
    multicastPush: { //true: from group-push, false: from chat-room
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      tempModelCSS: {
        top: 0
      }, // 新增訊息模板的 CSS
    };
  },
  mounted() {
    this.$EventBus.$on('openLinePointModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_line_point/getSerialHandler')
        .then(() => {

          vm.openModel();
          vm.$swal.close();
        });
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    // 發送點數訊息
    async productsPush(seq) {
      const vm = this;
      if(vm.users){ //from group-push
        if(vm.users.length == 0) {
        return;
      }
      if(vm.users.length > 1) { //阻擋多人選取&發送
        vm.$swal.fire({
          text: 'LINE Point發送 一次只能發送給一位客人哦！',
          icon: 'error', // success、error
          confirmButtonText: '確定',
        }).then(result => {
          if(result.isConfirmed) {
            vm.closeModel();
          }
        })
        return
      }
      }
      vm.sendPoint(seq);
    },
    async sendPoint(seq) {
      const vm = this;
      vm.$swal.fire({
          title: '確認發送',
          html: `是否要發送LINE Point?`, // html
          icon: 'warning', // success、error
          confirmButtonText: '確定',
          showCancelButton: true,
          cancelButtonText: '取消',
          reverseButtons: true,
      }).then(result => {
        if(result.isConfirmed) {
          vm.$swal.fire({
            title: '發送中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          if (vm.multicastPush) {// from group-push, 資料限制只能傳一人
            const data = {
              member_uuid: _.map(vm.users, (val) => val.member_line_uuid || val.line_uuid),
              sn_code_push_seq: seq
            };
            vm.$store.dispatch('sa_line_point/pushPointHandler', data)
              .then(() => {
                vm.$swal.fire({
                  title: '發送成功',
                  text: '請稍候再查看對話訊息',
                  icon: 'success',
                  timer: 3000,
                  showConfirmButton: false
              }).then((result) => {
                vm.$emit('closeModelHandler');
                vm.closeModel();
                vm.$swal.close();
              });
              });
          } else { // from chat-room
            const data = {
                member_uuid: [vm.user.member_uuid],
                sn_code_push_seq: seq
              };
              vm.$store.dispatch('sa_line_point/pushPointHandler', data)
                .then(() => {
                  vm.$swal.fire({
                    title: '發送成功',
                    text: '請稍候再查看對話訊息',
                    icon: 'success',
                    timer: 3000,
                    showConfirmButton: false
                }).then((result) => {
                  vm.$emit('closeModelHandler');
                  vm.closeModel();
                  vm.$swal.close();
                });
                });
          }
        }
      });
    }
  },
  beforeDestroy() {
    this.$EventBus.$off('openLinePointModel');
  },
  computed: {
    ...mapState({
      serials: (state) => state.sa_line_point.serials,
    }),
  },
};
</script>

<style lang="scss" scoped>

  @font-face {
    font-family: "icon";
    src: url("../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.2rem;
    margin-bottom: 4px;
  }

  .iconClose:before {
    content: "\e908";
  }

  .border-black{
    border: 0.2rem solid #000;
  }
  .outline-product {
    display: block;
    border-radius: 1rem;
    padding: 1rem;
    cursor: pointer;
  }
  .custom-shadow {
    -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
    box-shadow: 0.2rem 0.2rem 0 #00000033;
  }

  .custom-check-icon {
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    border-radius: 0.4rem;
    margin-right: 1.2rem;
    position: relative;
  }

  .custom_checker:checked ~ .input_wrap .custom-check-icon {
    background-color: #ef4852;
  }

  .custom_checker:checked ~ .input_wrap .custom-check-icon::after {
    display: block;
  }

  .custom-check-icon::after {
    content: '';
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 1.5rem;
    height: 1rem;
    background-image: url(../../assets/images/icon/check-1.png);
    background-size: 1.5rem;
    background-repeat: no-repeat;
  }

  .product_info {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 100px;
  }
  .product_info > .col {
    display: flex;
    align-items: center;
  }

  input[type="checkbox"], input[type="radio"] {
    position: absolute;
    width: 1px;
    height: 1px;
    display: none;
    opacity: 0;
  }
</style>

<style lang="scss">
  .el-radio {
    padding-top: 8px;
  }
  .el-cascader-menu {
    min-width: 40vw;
    max-width: 160px;
  }
  .el-cascader-node {
    padding-left: 10px;
  }
  .el-input__inner {
    border-radius: 20px;
    background-color: #eee;
  }
  .el-cascader-node__label {
    padding: 0;
  }
  .el-icon-circle-close {
    color: #333;
  }
  /*Fixes double tap on iOS*/
  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
</style>
